import * as materials from "materials/legacy/legacy-lava";
export { materials };
export default materials;
